const InfoTag = ({ children }) => {
  return (
    <div className="shadow shadow-secondary gap-2 flex flex-row h-7 rounded bg-primary text-xs py-1 px-2 text-white text-center">
      {children}
    </div>
  );
};

export default InfoTag;
